import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../../services/shared-data.service';
import { CpAuthenticationService } from '../../services/cp-authentication.service';
import { CpRolesEnum } from '../global-meta-data';
import { Router } from '@angular/router';


@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.scss']
})
export class LogoutModalComponent implements OnInit {
  userRoleName: string;
  userSelection;
  isRoleSelectionShown = false;
  isLoggedIn: Boolean = false;
  companyName: String = '';
  userName: String = '';
  lastLogin: string;
  roleNameMap = {
    [CpRolesEnum.INVESTOR]: 'Investor',
    [CpRolesEnum.IPA]: 'IPA',
    [CpRolesEnum.ISSUER]: 'Issuer'
  };
  constructor(
    private data: SharedDataService,
    private authenticationService: CpAuthenticationService,
    private router: Router
  ) {
  }

  logout() {
    this.authenticationService.logout(true);
  }

  ngOnInit() {

    this.data.loginObservable.subscribe((loginState) => {
      this.isLoggedIn = loginState;
      if (loginState && this.data.userData) {
        this.userName = this.data.userData.username;
        this.companyName = this.data.userData.companyName;
        this.lastLogin = this.data.userData.auth_details.last_login;
      }
    });

    this.data.userSelectionObservable.subscribe(userSelectionState => {
      this.isRoleSelectionShown = userSelectionState;
      if (userSelectionState) {
        this.userSelection = this.data.getUserSelectionFromLS();
        this.userRoleName = this.getUserRoleName();
      }
    });
  }

  getUserRoleName() {
    const { userSelection } = this;
    if (!userSelection) {
      return '';
    }
    if (userSelection.iscadmin && !userSelection.instrumentType && !userSelection.divisionId &&
      !userSelection.roleId && !userSelection.instrumentId) {
      return 'Admin';
    } else if (!userSelection.iscadmin && userSelection.roleId && userSelection.roleType) {
      return this.roleNameMap[userSelection.roleType];
    }

    return '';
  }

  onChangeRoleClick() {
    if (this.userSelection.hasMultipleRoles) {
      this.router.navigate(['/user-role/']);
    }
  }

}
